import type { NcsColorOption } from "./ncsColors";

/**
 * Filters NCS colors by name or short code (case-insensitive).
 * Empty/whitespace query returns the full list.
 */
export function filterNcsColors(
  colors: NcsColorOption[],
  query: string,
): NcsColorOption[] {
  const trimmed = query.trim();
  if (!trimmed) {
    return colors;
  }
  const searchUpper = trimmed.toUpperCase();
  return colors.filter((color) => {
    const name = color.name.toUpperCase();
    const code = color.name.replace(/^NCS\s+/i, "").toUpperCase();
    return name.includes(searchUpper) || code.includes(searchUpper);
  });
}
